export default __webpack_public_path__ + "static/media/374.9c5facc0.gif";